import { cn } from '@/lib/utils';
import { normalizeSocialUrl } from '@/lib/social-links';
import { SOCIAL_PLATFORMS } from './social-platforms';

interface SocialLinksProps {
  socialLinks?: Record<string, string> | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeMap = {
  sm: { box: 'h-7 w-7', icon: 'h-3.5 w-3.5' },
  md: { box: 'h-9 w-9', icon: 'h-4 w-4' },
  lg: { box: 'h-11 w-11', icon: 'h-5 w-5' },
};

export function SocialLinks({ socialLinks, size = 'md', className }: SocialLinksProps) {
  if (!socialLinks || typeof socialLinks !== 'object') return null;

  const entries = SOCIAL_PLATFORMS.filter((p) => {
    const val = socialLinks[p.key];
    return val && val.trim().length > 0;
  });

  if (entries.length === 0) return null;

  const s = sizeMap[size];

  return (
    <div className={cn('flex items-center gap-1.5', className)}>
      {entries.map(({ key, label, icon: Icon, color }) => {
        const result = normalizeSocialUrl(key, socialLinks[key] || '');
        if (!result.ok) return null;
        return (
          <a
            key={key}
            href={result.url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            title={label}
            className={cn(
              'inline-flex items-center justify-center rounded-full border border-border/60 bg-background transition-all hover:scale-110 hover:shadow-md',
              s.box
            )}
            style={{ color }}
          >
            <Icon className={s.icon} />
            <span className="sr-only">{label}</span>
          </a>
        );
      })}
    </div>
  );
}
